<template>
  <!-- 活动-转盘活动配置-添加奖品 -->
  <div>
    <el-dialog
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      title="添加物品"
      width="400px"
      @close="closeDialog"
    >
      <el-form
        :model="dataForm"
        ref="dataForm"
        label-width="100px"
        size="small"
        :rules="replyRules"
      >
        <el-form-item label="转盘类型">
          <el-select
            style="width: 140px"
            v-model="dataForm.box_type"
            placeholder="请选择配置状态"
          >
            <el-option label="热血盲盒转盘" :value="1"></el-option>
            <el-option label="普通盲盒转盘" :value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="奖品类型">
          <el-select
            style="width: 140px"
            v-model="dataForm.goods_type"
            placeholder="请选择配置状态"
          >
            <el-option label="物品" :value="1"></el-option>
            <el-option label="钻石" :value="2"></el-option>
            <el-option label="商城币" :value="3"></el-option>
            <el-option label="coins币" :value="4"></el-option>
            <el-option label="活动商城币" :value="5"></el-option>
            <el-option label="游戏次数" :value="6"></el-option>
            <el-option label="钥匙" :value="8"></el-option>
            <el-option label="无奖励" :value="7"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="物品名称">
          <el-input
            style="width: 200px; margin-right: 20px"
            placeholder="请输入物品名称"
            v-model="dataForm.name"
          ></el-input>
        </el-form-item>
        <el-form-item label="物品图片" v-if="dataForm.goods_type != 1">
          <ImgUpload v-model="dataForm.img"></ImgUpload>
        </el-form-item>
        <el-form-item label="奖品信息" v-if="dataForm.goods_type === 1">
          <AddGoods
            :prizeInfo="prizeInfo"
            @selectedData="getSelectedData"
          ></AddGoods>
        </el-form-item>
        <el-form-item
          label="奖励金额"
          v-if="
            dataForm.goods_type === 2 ||
            dataForm.goods_type === 3 ||
            dataForm.goods_type === 4 ||
            dataForm.goods_type === 5
          "
        >
          <el-input
            style="width: 200px; margin-right: 20px"
            placeholder="请输入奖励金额"
            v-model="dataForm.balance_amount"
          ></el-input>
        </el-form-item>
        <el-form-item label="奖励次数" v-if="dataForm.goods_type === 6">
          <el-input
            style="width: 200px; margin-right: 20px"
            placeholder="请输入奖励次数"
            v-model="dataForm.reward_num"
          ></el-input>
        </el-form-item>
        <el-form-item label="钥匙id" v-if="dataForm.goods_type === 8">
          <el-input
            style="width: 200px; margin-right: 20px"
            placeholder="请输入钥匙id"
            v-model="dataForm.prize_id"
          ></el-input>
        </el-form-item>
        <el-form-item label="权重">
          <el-input
            style="width: 200px; margin-right: 20px"
            placeholder="请输入权重"
            v-model="dataForm.weight"
          ></el-input>
        </el-form-item>
        <el-form-item label="概率">
          <el-input
            style="width: 200px; margin-right: 20px"
            placeholder="请输入概率"
            v-model="dataForm.probability"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button @click="closeDialog">取消</el-button>
          <el-button type="primary" @click="submit" :loading="buttonLoading"
            >确定</el-button
          >
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import http, { server, api, delApiData, getApiData, postApiData, patchApiData } from '@/http'
import { getCookie } from '@/utils/cookie'
import saveFile from '@/utils/saveFile'
import AddGoods from '@/components/goods/AddGoods.vue'
import AddDebris from '@/components/debrisActivity/AddDebris.vue'
import ImgUpload from '@/components/common/ImgUpload.vue'

export default {
  components: {
    AddGoods,
    AddDebris,
    ImgUpload
  },
  props: {
    visible: {//展示标志
      type: Boolean,
      default: false
    },
    value: {//数据
      type: Object,
      default: undefined
    },
    type: {//弹窗类型
      type: Number,
      default: 1
    }
  },
  data() {
    return {
      loading: false,//加载动画
      buttonLoading: false,//按钮加载动画
      imgType: 'prize',//上传图片的种类 奖品
      dataForm: {
        img: '',//图片
        box_type: '',//盲盒类型
        goods_type: 1,//1是物品 2是钻石 3是金币
        name: '',//物品名称
        reward_num: 0,//奖励次数
        prize_id: 0,//物品id
        balance_amount: 0,//奖励金额
        weight: '',//权重
        probability: '',//概率
      },
      prizeInfo: undefined,//选择的物品的信息
      replyRules: {//回复弹窗规则验证
      }
    }
  },
  computed: {
    ...mapState({
      ImgUpload
    }),
    headers() {
      return {
        Authorization: 'Bearer ' + getCookie('access_token')
      }
    },
    action() {
      return `${server}file`
    },
    dialogVisible: {
      get() {
        return this.visible
      },
      set() {
      }
    },
    fromInfo: {
      get() {
        return this.value
      },
      set() {
      }
    },
  },
  watch: {
    dialogVisible(val) {
      if (val && this.fromInfo) {
        this.dataForm = this.fromInfo
        this.prizeInfo = this.fromInfo
        this.prizeInfo.image = this.fromInfo.img
      } else if (val && !this.fromInfo) {
        this.prizeInfo = undefined
        this.dataForm = {
          box_type: '',//盲盒类型
          goods_type: 1,//1是物品 2是钻石 3是金币
          name: '',//物品名称
          reward_num: 0,//奖励次数
          prize_id: 0,//物品id
          balance_amount: 0,//金额
          weight: '',//权重
          probability: '',//概率
        }
      }
    },
  },
  created() {
  },
  methods: {
    submit() {
      //保存任务
      //表单验证后发起请求
      this.buttonLoading = true
      let params = this.dataForm
      if (this.type === 1) {
        postApiData(`turntable`, params).then(res => {
          this.$message.success("添加成功")
          this.$emit('refresh')
          this.closeDialog()
        }).finally(() => {
          this.buttonLoading = false
        })
      } else {
        patchApiData(`turntable/${params.id}`, params).then(res => {
          this.$message.success("添加成功")
          this.$emit('refresh')
          this.closeDialog()
        }).finally(() => {
          this.buttonLoading = false
        })
      }

    },
    getSelectedData(data) {
      //选择物品数据
      this.prizeInfo = data
      this.dataForm.prize_id = data.id
      this.dataForm.name = data.name
      this.dataForm.img = data.image
    },
    // getSelectedDebrisData(data) {
    //   // 选择碎片数据
    //   if (this.dataForm.content.length >= 6) {
    //     this.$message.error("最多选择六个碎片")
    //     return
    //   }
    //   this.dataForm.content.push(data)
    // },
    deleteItem(index) {
      this.dataForm.content.splice(index, 1)
    },
    beforeImageUpload(file) {
      if (file.size > 2 * 1024 * 1024) {
        this.$message.error('图片尺寸过大，请选择2M大小以下的图片上传')
        return false
      }
    },
    handleUploadSuccess(res) {
      if (res.path) {
        this.dataForm.img = res.path
      } else {
        this.$message.error('上传失败')
      }
      this.$refs['dataForm'].validateField('img')
    },
    closeDialog() {
      //关闭弹窗
      this.$emit("close")
    }
  }

}
</script>
<style lang="less" scoped>
.selected-debris-box {
  display: flex;
  align-items: center;
  font-size: 12px;
  margin-bottom: 5px;
  line-height: 20px;
  img {
    width: 50px;
    margin-right: 10px;
  }
  .delete-btn {
    cursor: pointer;
    flex-shrink: 0;
    margin-left: 10px;
    color: rgba(255, 0, 0, 0.8);
    &:hover {
      color: rgba(255, 0, 0, 1);
    }
  }
}
</style>